module.exports = __webpack_public_path__ + "img/MX-B048046C-BD.b8633a95.png";